import _util from '../../utils/';


const ComplainApprovalService = {
	selectComplainApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalAttendanceComplaint/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	deleteComplainApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/BatchDelete',
			method: "delete",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateComplainApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalAttendanceComplaint/Approval',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	updateComplainBatchAApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRApprovalAttendanceComplaint/BatchApproval',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	createComplainApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	},
	exportComplainApproval(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryAirticketSubsidy/Export',
			data: data,
			success: resolve,
			error: reject
		})
	},
    fetchCcToMe(data, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalAttendanceComplaint/Get',
            params: data,
            success: resolve,
            error: reject
        })
    },
    fetchApproved(data, resolve, reject) {
        _util.request({
            url: '/api/HRApprovalAttendanceComplaint/Get',
            params: data,
            success: resolve,
            error: reject
        })
    },
};


export default ComplainApprovalService;


// WEBPACK FOOTER //
// ./src/services/Approval/complain-approval-service.js